import loadable from '@loadable/component';
import React from 'react';

/* istanbul ignore next */
export default loadable(
    () =>
        import(
            /* webpackChunkName: "PaypalIncompatibleBasketMessageLazy" */ './PaypalIncompatibleBasketMessage'
        ),
    {
        fallback: <div />,
    }
);
